import {
    CmpsInsightCoachingPerformanceDropDownContent,
    SubMenu,
} from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { SystemComponent } from '../../insight/config.insight.model';
import { epicDependencies } from '../../store';
import { PerformanceDataViewTypeTranslationMap } from '../constants/performance-data-view-type-translation-map.ts';
import { CustomPerformanceDataViewType } from '../models/customer-performance-data-view-type.enum';
import { DropdownMenuValues } from '../models/drop-down-menu-values.enum';
import { PerformanceCardPillarData } from '../models/performance-card-pillar-data.model';
import { TranslationKeyMap } from '../my-performance-card.i18n';

export function getDropDownData(
    data: PerformanceCardPillarData[],
    component?: SystemComponent,
): CmpsInsightCoachingPerformanceDropDownContent[] {
    if (epicDependencies == null || epicDependencies.injector == null) {
        return [];
    }
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);

    const createSubMenu = (pillarData: PerformanceCardPillarData): SubMenu => ({
        value: translateService.instant(
            PerformanceDataViewTypeTranslationMap[pillarData.viewType],
        ),
        id: pillarData.viewType,
        isChecked: false,
    });

    const createDropDownContent = (
        titleKey: string,
        id: DropdownMenuValues,
        subMenu: SubMenu[],
    ): CmpsInsightCoachingPerformanceDropDownContent => ({
        title: translateService.instant(titleKey),
        id,
        subMenu,
    });

    const peerCompareSubMenu = data?.map(createSubMenu) ?? [];
    let dropdownContent: CmpsInsightCoachingPerformanceDropDownContent[] = [
        createDropDownContent(
            TranslationKeyMap._9918_PEER_COMPARE,
            DropdownMenuValues.PEER_COMPARE,
            peerCompareSubMenu,
        ),
        createDropDownContent(
            TranslationKeyMap._9942_PERIOD_COMPARE,
            DropdownMenuValues.PERIOD_COMPARE,
            [],
        ),
        createDropDownContent(
            TranslationKeyMap._10059_POPULATION_COMPARE,
            DropdownMenuValues.POPULATION_COMPARE,
            [],
        ),
        createDropDownContent(
            TranslationKeyMap._9943_LAUNCH_RADIAL,
            DropdownMenuValues.LAUNCH_RADIAL,
            [],
        ),
    ];

    if (component === SystemComponent.HUMAN_INSIGHT) {
        dropdownContent = dropdownContent.filter(
            (e) => e.id !== DropdownMenuValues.POPULATION_COMPARE,
        );
        const customPopulationViewMenu: SubMenu = {
            value: translateService.instant(TranslationKeyMap._9603_OTHER),
            id: CustomPerformanceDataViewType.POPULATION_VIEW,
            isChecked: false,
        };
        dropdownContent[0].subMenu.push(customPopulationViewMenu);
    }

    if (component === SystemComponent.PERFORMANCE_INSIGHT) {
        dropdownContent = dropdownContent.filter(
            (e) => e.id !== DropdownMenuValues.PEER_COMPARE,
        );
        dropdownContent.sort((a, b) =>
            a.id === DropdownMenuValues.POPULATION_COMPARE
                ? -1
                : b.id === DropdownMenuValues.POPULATION_COMPARE
                ? 1
                : 0,
        );
    }

    return dropdownContent;
}
